<template>
	<div>
		<label v-if="!isPlaceholder" class="form-label pb-1" :for="name" v-text="label"></label>
		<input class="form-input w-full" :id="name" :name="name" :value="value" v-on="listeners" v-bind="$attrs" :placeholder="placeholder">
		<span class="error-message"></span>
		<!--<span class="error-message" v-if="form.errors.has(name)" v-text="form.errors.get(name)"></span>-->
	</div>
</template>
<script>
export default {
    name: 'a-input',
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        value: {},
        isPlaceholder: {
            type: Boolean
        }
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                input: (event) => this.$emit('input', event.target.value)
            };
        },
        placeholder() {
            if (
                this.$breakpoint.val === 'xs' ||
                this.$breakpoint.val === 'sm' ||
                this.isPlaceholder
            )
                return this.label;
            else return '';
        }
    }
};
</script>
